export default "__VITE_ASSET__52ec3dc7__"